import Text from '@commons/components/Text';
import type { DrupalBlock, DrupalText } from '@commons/types/drupal';

/**
 * Page title field block component.
 */

const PageTitleFieldBlock = ({ content }: DrupalBlock<DrupalText>) => {
  if (!content.value) return null;

  return (
    <Text as="h1" level="h2" transform="uppercase" marginBottom="none">
      {content.value}
    </Text>
  );
};

export default PageTitleFieldBlock;
